'use client';
export { default } from './components/LeaderboardClient';
